module.exports = __webpack_public_path__ + "img/tarde_c2@2x.fe9c6439.png";